function newMagicData(initialValue) {

	if (initialValue === undefined) initialValue = null
	var value = JSON.stringify(initialValue)
	var changeCbs = []
	var magicData = {}

	magicData.getValue = function() {
		return JSON.parse(value)
	}

	magicData.setValue = function(newValue, changeCbToIgnore) {
		if (newValue === undefined) newValue = null
		newValue = JSON.stringify(newValue)
		if (newValue === value) return
		let oldValue = value
		value = newValue
		for (var i in changeCbs) {
			var cb = changeCbs[i]
			if (cb === changeCbToIgnore) continue
			cb(JSON.parse(newValue), JSON.parse(oldValue))
		}
	}

	magicData.addChangeCb = function(cb, initialize = true) {
		var index = changeCbs.indexOf(cb)
		if (index !== -1) return
		changeCbs.push(cb)
		if (initialize) cb(JSON.parse(value))
	}

	magicData.removeChangeCb = function(cb) {
		var index = changeCbs.indexOf(cb)
		if (index === -1) throw new Error()
		changeCbs.splice(index, 1)
	}

	return magicData

}

export default {
	newMagicData: newMagicData
}
